<template>
  <CardWithTitle
    :item-id="itemId"
    :request-status="requestStatus"
    :options-data="optionsData"
    @call-option-menu="callOptionMenu"
    @reload="getData"
  >
    <v-row
      no-gutters
      justify="center"
    >
      <v-col cols="12">
        <v-data-table
          fixed-header
          :headers="headers"
          :items="tableData"
          disable-pagination
          :items-per-page="99"
          hide-default-footer
          flat
          height="100%"
        />
      </v-col>
    </v-row>

    <template #top-right-slot>
      <Badge
        v-if="hasFilterApplied && isEditor"
        type="info"
        :tooltip="$t('components.Badge.label.tooltip.info')"
        :value="$t('components.Badge.label.icon.key')"
        :preset="true"
      />
    </template>
  </CardWithTitle>
</template>

<script>
import { CHANNELS_BLIP_CHAT } from '@/store/modules/cards/constants';
import { mapActions } from 'vuex';
import EventBus from '@/utils/event-bus';
import exportModel from '@/mixins/export-model';
import cardsModel from '@/mixins/cards-model';
import CardWithTitle from '@/components/cards/models/CardWithTitle';
import Badge from '@/components/Badge';
import blipModel from '@/mixins/blip-model';

export default {
  name: 'BlipActiveMessagesByChannel',
  components: {
    CardWithTitle,
    Badge,
  },
  mixins: [
    cardsModel,
    exportModel,
    blipModel,
  ],
  props: {
    title: {
      type: String,
      required: true,
    },
    itemId: {
      type: [String, Number],
      required: true,
    },
    servicePath: {
      type: String,
      required: true,
    },
    interval: {
      type: String,
      default: 'D',
    },
  },
  data() {
    return {
      requestStatus: 'loading',
      tableData: [],
      headers: [
        {
          text: this.$t('components.BlipActiveMessagesByChannel.label.table.header.text.domain'),
          value: 'domain',
        },
        {
          text: this.$t('components.BlipActiveMessagesByChannel.label.table.header.text.count'),
          value: 'count',
        },
      ],
    };
  },
  computed: {
    optionsData() {
      return this.baseCardOptions.concat(this.exportOptionsData).sort((actualOption, prevOption) => this.sortMenuOptions(actualOption, prevOption));
    },
  },
  created() {
    this.getData();
  },
  methods: {
    ...mapActions('cards', [
      'getBlipService',
      'hasNoBlipBotAndContractFiltered',
      'getAppliedCardFilter',
    ]),
    async getData(options) {
      const appliedCardFilter = await this.getAppliedCardFilter(this.itemId);

      if (!options?.silentRefresh) {
        this.requestStatus = 'loading';
      }

      if (await this.hasNoBlipBotAndContractFiltered(this.itemId)) {
        this.requestStatus = 'emptyBot';
        return;
      }

      if (!this.isSingleBotSelected(appliedCardFilter)) {
        this.requestStatus = 'supportsOnlyOneBot';
        return;
      }

      this.getBlipService({
        servicePath: this.servicePath,
        interval: this.interval,
        itemId: this.itemId,
      })
        .then((response) => {
          if (!response) {
            this.requestStatus = 'error';
            return;
          }

          this.rawSeries = this.returnBlipSingleBotResponse(response).resource.items;
          this.requestStatus = 'success';

          this.tableData = this.rawSeries.map(serie => ({ domain: CHANNELS_BLIP_CHAT[serie.domain], count: serie.count }));

          if (options?.silentRefresh) {
            EventBus.$emit('updated', { itemId: this.itemId });
          }
        })
        .catch((error) => {
          console.error(error);
          this.requestStatus = error.message;
        });
    },
  },
};
</script>

<style scoped lang="scss">
  ::v-deep {
    .v-data-table--fixed-header thead th {
      background: transparent !important;
    }

    .v-data-table--fixed-header thead th span {
      margin-right: var(--ds-spacing-stack-nano);
    }
  }
</style>
